import React from 'react';
import { Box } from 'rebass';
import classNames from 'classnames';

/**
 * A skeleton component.
 *
 * @param {string|number} height - The height of the skeleton.
 * @param {string|number} [width] - The width of the skeleton.
 * @param {string} className
 * @param {React.CSSProperties} style
 */
export function Skeleton({ height, width, className, style }) {
    return <Box className={classNames('skeleton', className)} width={width} height={height} style={style} />;
}
